import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Store for managing UI states in the Shop The Collection (STC) experience,
 * such as the visibility of bottom sheets and modals.
 */
export const useShopTheCollectionUIStore = defineStore('shopTheCollectionUI', () => {
  const activeBottomSheetProductId = ref<string | null>(null);
  const activeBottomSheetUpcId = ref<string | null>(null);

  const openBottomSheet = (productId: string, upcId?: string) => {
    activeBottomSheetProductId.value = productId;
    activeBottomSheetUpcId.value = upcId || null;
  };

  const closeBottomSheet = () => {
    activeBottomSheetProductId.value = null;
    activeBottomSheetUpcId.value = null;
  };

  return {
    activeBottomSheetProductId,
    activeBottomSheetUpcId,
    openBottomSheet,
    closeBottomSheet,
  };
});
